import ShopMyStoreHeader from 'components/ShopYourStore/ShopMyStoreHeader/ShopMyStoreHeader';
import { withShopMyStoreHeaderProps } from 'components/ShopYourStore/ShopMyStoreHeader/withShopMyStoreHeaderProps';

export default withShopMyStoreHeaderProps(ShopMyStoreHeader);
